import Tippy from '@tippyjs/react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './Tooltip.module.scss';

const cx = classNames.bind(styles);

const Tooltip = ({ children, tooltip }) => (
  <Tippy className={cx('container')} content={tooltip} duration={0}>
    {children}
  </Tippy>
);

Tooltip.propTypes = {
  children: PropTypes.node.isRequired,
  tooltip: PropTypes.string.isRequired,
};

export default Tooltip;
